import { initSlimSelects } from "../component/custom-select.js";
import { initCallNow } from "../component/call-now.js";
import { initAccordionGroups } from "../component/accordion.js";
import { initSteps } from "../component/steps.js";
import { equalHeight } from "../component/equal-height";
import { initBlogSlider } from "../component/insights.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initTechStackLabels } from "../component/tech-stack-label.js";
import { initCaseStudiesCarousel } from "../component/case-studies-carousel.js";
import { initWhyCarousel } from "../component/why-carousel.js";
import { initTechTabs } from "../component/tech-tabs.js";
import {
    initCookieBar,
    initDmcabadge,
    initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import { initLandingExpertForm } from '../component/landing-form-submission.js';
import { initGlowWrapper } from "../component/glow.js";

initDmcabadge();
initCookieBar();
initSlimSelects();
initAccordionGroups();
initOfficeHoverReveal();
initGooglePreferredSource();
initLandingExpertForm();
document.addEventListener("DOMContentLoaded", function () {
    initCallNow();
    initGlowWrapper();
});
initSteps();
initBlogSlider();
initTechStackLabels();
initCaseStudiesCarousel();
initWhyCarousel();
initTechTabs();

const updateEqualHeight = () => {
    equalHeight(
      ".why-choose-section .why-card h3"
    );
    equalHeight(
        ".tatva-service-section .work-item h3"
    );
};

updateEqualHeight();

window.addEventListener("load", () => {
    updateEqualHeight();
});

window.addEventListener("resize", () => {
    updateEqualHeight();
});